import moment from 'moment-timezone';
import { getEmpresaField } from './getEmpresaField';

const DEFAULT_TIMEZONE = 'America/Sao_Paulo';

/**
 * Retorna o timezone da empresa salva no localStorage.
 * Fallback: 'America/Sao_Paulo'
 */
export function getEmpresaTimezone() {
    return getEmpresaField('timezone', DEFAULT_TIMEZONE);
}

/**
 * Formata uma data usando o timezone da empresa.
 * @param {Date|string} date - Data a formatar
 * @param {string} format - Formato moment (default: 'DD/MM/YYYY HH:mm')
 * @returns {string} Data formatada
 */
export function formatDateTz(date, format = 'DD/MM/YYYY HH:mm') {
    if (!date) return '-';
    return moment(date).tz(getEmpresaTimezone()).format(format);
}

/**
 * Retorna o "agora" no timezone da empresa (objeto moment-timezone).
 * Útil para cálculos de período, startOf('day'), subtract(), etc.
 * @returns {moment.Moment}
 */
export function nowTz() {
    return moment().tz(getEmpresaTimezone());
}

/**
 * Converte uma data para o timezone da empresa (objeto moment-timezone).
 * @param {Date|string} date
 * @returns {moment.Moment}
 */
export function toTz(date) {
    return moment(date).tz(getEmpresaTimezone());
}

/**
 * Atualiza campos específicos da empresa no localStorage sem precisar de re-login.
 * Mescla os campos passados com os dados existentes.
 * @param {Object} updatedFields - Campos a atualizar (ex: { timezone: 'America/New_York' })
 */
export function updateEmpresaLocalStorage(updatedFields) {
    try {
        const current = JSON.parse(localStorage.getItem('empresa'));
        if (current) {
            const updated = { ...current, ...updatedFields };
            localStorage.setItem('empresa', JSON.stringify(updated));
        }
    } catch (e) {
        console.error('[timezone] Erro ao atualizar empresa no localStorage:', e);
    }
}
